import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Collapse, Button, Divider } from 'antd';
import SvgIcon from '&/components/SvgIcon';
import { CloseOutlined } from '@ant-design/icons';
import './quickStart.scss';

export default function QuickStart(props) {
    const [progressValue, setProgressValue] = useState({ '--progress': '0' });
    const [guidanceData, setGuidanceData] = useState({});

    const history = useHistory();

    useEffect(() => {
        if (props.guidanceData) {
            setGuidanceData(props.guidanceData);
            const keys = Object.keys(props.guidanceData);
            const totalLength = keys.length;
            const doneLength = keys.filter(
                key => +props.guidanceData[key] === 1
            ).length;
            setProgressValue({
                '--progress': `${(doneLength / totalLength) * 100}%`,
            });
            setGuidanceData(props.guidanceData);
        }
    }, [props.guidanceData]);

    const guideList = [
        {
            title: intl.get('dataBoard.quickStart.roleTitle'),
            description: intl.get('dataBoard.quickStart.roleDesc'),
            key: 'entRole',
            buttonText: intl.get('dataBoard.quickStart.gotoManage'),
            path: '/user-center/role-authority',
        },
        {
            title: intl.get('dataBoard.quickStart.orgMemberTitle'),
            description: intl.get('dataBoard.quickStart.orgMemberDesc'),
            key: 'entOrg',
            buttonText: intl.get('dataBoard.quickStart.gotoAdd'),
            path: '/user-center/organization',
        },
        {
            title: intl.get('dataBoard.quickStart.planTempTitle'),
            description: intl.get('dataBoard.quickStart.planTempDesc'),
            key: 'entPlanTemp',
            buttonText: intl.get('dataBoard.quickStart.gotoSet'),
            path: '/user-center/template-setting?item=constructionTemplate',
        },
        {
            title: intl.get('dataBoard.quickStart.notepadTempTitle'),
            description: intl.get('dataBoard.quickStart.notepadTempDesc'),
            key: 'entNotepadTemp',
            buttonText: intl.get('dataBoard.quickStart.gotoSet'),
            path: '/user-center/template-setting?item=decorateTemplate',
        },
        {
            title: intl.get('dataBoard.quickStart.examineTempTitle'),
            description: intl.get('dataBoard.quickStart.examineTempDesc'),
            key: 'entExamineTemp',
            buttonText: intl.get('dataBoard.quickStart.gotoSet'),
            path: '/user-center/template-setting?item=inspectionTemplate',
        },
        {
            title: intl.get('dataBoard.quickStart.inspectTempTitle'),
            description: intl.get('dataBoard.quickStart.inspectTempDesc'),
            key: 'entInspectTemp',
            buttonText: intl.get('dataBoard.quickStart.gotoSet'),
            path: '/user-center/template-setting?item=acceptanceTemplate',
        },
        {
            title: intl.get('dataBoard.quickStart.messageTitle'),
            description: intl.get('dataBoard.quickStart.messageDesc'),
            key: 'entMessageTemp',
            buttonText: intl.get('dataBoard.quickStart.gotoSend'),
            path: '/user-center/steward-center',
        },
    ];

    const collapsePanel = item => {
        return (
            <div className="quick-start-item-header">
                <SvgIcon
                    iconName={
                        +guidanceData[item.key] === 1
                            ? 'Icon-Radio-Checked'
                            : 'Icon-Radio-Unchecked'
                    }
                    className="radio-icon"
                />
                <span className="quick-title">{item.title}</span>
            </div>
        );
    };

    const gotoSetting = path => {
        history.push(path);
    };

    return (
        <div className="quick-start-wrap">
            <div className="scroll-wrap">
                <div className="quick-start-header">
                    <CloseOutlined
                        className="close-btn"
                        onClick={() => props.closeHandler()}
                    />
                    <div className="header-title-content">
                        <h2 className="title">
                            {intl.get('dataBoard.quickStart.title')}
                        </h2>
                        <p className="title-desc">
                            {intl.get('dataBoard.quickStart.desc')}
                        </p>
                        <div className="progress-bar" style={progressValue} />
                    </div>
                </div>
                <div className="quick-start-body">
                    <Collapse accordion ghost expandIconPosition="end">
                        {guideList.map(item => {
                            return (
                                <Collapse.Panel
                                    className="quick-start-item"
                                    header={collapsePanel(item)}
                                    key={item.key}>
                                    <Divider
                                        orientation="center"
                                        type="horizontal"
                                        className="title-divider"
                                    />
                                    <p className="description">
                                        {item.description}
                                    </p>
                                    <div className="item-footer">
                                        <Button
                                            type="primary"
                                            size="small"
                                            onClick={() =>
                                                gotoSetting(item.path)
                                            }>
                                            {item.buttonText}
                                        </Button>
                                    </div>
                                </Collapse.Panel>
                            );
                        })}
                    </Collapse>
                </div>
            </div>
            <p
                className="close-quick-start"
                onClick={props.closeSettingHandler}>
                {intl.get('dataBoard.quickStart.close')}
            </p>
        </div>
    );
}
